// Owner-editable organization details for the homepage's structured data.
export const organization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://popivnenko.com/#organization',
    name: 'Triad Teacher Training',
    url: 'https://popivnenko.com/',
    logo: 'https://popivnenko.com/assets/logo.png',
    founder: {
        '@type': 'Person',
        name: 'Olha Popivnenko',
    },
    sameAs: [
        'https://www.instagram.com/olha_popivnenko/',
        'https://www.tiktok.com/@olha_popivnenko',
    ],
};
